(() => {
	const expandBtns = document.querySelectorAll<HTMLElement>(".expand-btn");
	const wrappers = document.querySelectorAll<HTMLElement>(
		".job-content-wrapper",
	);

	// Initialize: Check height
	wrappers.forEach((wrapper) => {
		// Check if content is actually tall enough to collapse
		if (wrapper.scrollHeight > 80) {
			wrapper.classList.add("collapsed");
		} else {
			// If content is short, hide the expand button associated with it
			const parent = wrapper.closest(".card-middle");
			const btn = parent?.querySelector(".expand-btn") as HTMLElement;
			if (btn) {
				btn.style.display = "none";
			}
		}
	});

	expandBtns.forEach((btn) => {
		btn.addEventListener("click", function () {
			const cardMiddle = this.closest(".card-middle");
			if (!cardMiddle) return;

			const wrapper = cardMiddle.querySelector(".job-content-wrapper");
			if (!wrapper) return;

			const isCollapsed = wrapper.classList.contains("collapsed");
			const expandText = this.getAttribute("data-expand-text") || "展开";
			const collapseText = this.getAttribute("data-collapse-text") || "收起";

			if (isCollapsed) {
				wrapper.classList.remove("collapsed");
				this.innerText = collapseText;
			} else {
				wrapper.classList.add("collapsed");
				this.innerText = expandText;
			}
		});
	});
})();
